import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { usePosition, useShow } from "@website/ui/mini-popover/hooks";
import styles from "@website/ui/mini-popover/mini-popover.module.scss";
import { MiniPopoverPropertiesType } from "@website/ui/mini-popover/mini-popover.types";
import { TransitionV2 } from "@website/ui/transition";
import { isSSR } from "@website/utils/is-ssr";
import { FC, memo, useRef } from "react";
import { createPortal } from "react-dom";

const MiniPopover: FC<MiniPopoverPropertiesType> = (properties) => {
  const {
    animate,
    children,
    title,
    fullWidth,
    gap,
    className,
    usePortal = false
  } = properties;
  const popoverReference = useRef<HTMLDivElement>(null);
  const {
    popoverProperties,
    transitionProps,
    closeButtonProps,
    popoverOpen,
    animateOpen
  } = useShow(properties, popoverReference);
  const { horizontalPosition } = usePosition(properties, popoverReference);
  const { isMobile } = useViewPort();

  const content = (
    <TransitionV2 {...transitionProps} in={animateOpen}>
      {(state) => (
        <div
          className={`${className} ${styles["container"]} ${
            animate === "normal"
              ? ""
              : `${styles["animate-bottom"]} ${styles[state]}`
          } ${fullWidth ? styles["full"] : ""} ${styles[horizontalPosition]} `}
          style={{ marginTop: isMobile ? "0px" : gap || "0px" }}
          // ref={sheetReference}
          // style={isMobile ? { bottom: `${sheetBottom}px` } : {}}
          // style={{ height: isMobile ? `${containerHeight}px` : "auto" }}
        >
          <div
            ref={popoverReference}
            {...popoverProperties}
            className={`${styles["mini-popover"]} `}
          >
            {title ? (
              <div className={styles["header"]}>
                <div className={styles["title"]}>{title}</div>
                <div className={styles["close-button"]}>
                  <MaterialIcon
                    className={styles["close-button-icon"]}
                    name="close"
                    {...closeButtonProps}
                  />
                </div>
              </div>
            ) : null}
            <div className={styles["main"]}>{children}</div>
          </div>
        </div>
      )}
    </TransitionV2>
  );

  if (popoverOpen) {
    if (isSSR()) null;
    return usePortal ? createPortal(content, document.body) : content;
  }
  return null;
};

const MiniPopoverMemoized = memo(MiniPopover);
export { MiniPopoverMemoized as MiniPopover };
